{
  "pageTitle": "Računi",
  "noInvoicesFound": "Nema pronađenih računa",
  "noInvoicesHint": "Pokušajte prilagoditi filtere ili pokrenite skupljanje da uvezete račune.",
  "filterStatus": "Status",
  "filterProvider": "Pružatelj",
  "filterAddress": "Adresa",
  "filterDate": "Datum",
  "dateFrom": "Od",
  "dateTo": "Do",
  "show": "Prikaži",
  "perPage": "po stranici",
  "tapToOpen": "Dodirni za otvaranje",
  "edit": "Uredi",
  "delete": "Obriši",
  "clearAll": "Očisti sve",
  "pagination": {
    "range": "Prikazano {{start}}–{{end}} od {{total}}"
  },
  "detail": {
    "date": "Datum",
    "createdAt": "Kreirano",
    "address": "Adresa",
    "provider": "Pružatelj",
    "amount": "Iznos",
    "status": "Status",
    "datePaid": "Plaćeno",
    "reference": "Referenca",
    "taxDeduction": "Porezna stopa",
    "skipPayment": "Plaćanje"
  },
  "results": "Rezultati",
  "deleteConfirmTitle": "Obrisati račun?",
  "deleteConfirmMessage": "Račun #{{id}} će biti uklonjen sa liste."
}
